import { useQuery } from "react-query";
import { getWidgetSettingByKey } from "../api/cosmos-api";

const useWidgetSettingsByKey = ({ enabled, key, widgetId }) => {
  const { isLoading: isWidgetSettingsLoading, data: widgetSettingsData = {} } =
    useQuery([`${key}-widget-settings`, { widgetId }], getWidgetSettingByKey, {
      retry: 0,
      enabled,
      select: (response) => {
        const { data } = response;
        return data;
      },
    });

  return { isWidgetSettingsLoading, widgetSettingsData };
};

export default useWidgetSettingsByKey;
